















import { Component, Prop } from 'vue-property-decorator';
import { MenuDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
import Vue from 'vue';

@Component({
  components: {CmsLink},
})
export default class HeaderCmsMenu extends Vue {
  @Prop({required: true})
  public readonly model!: MenuDto;

  private close(): void {
    this.$emit('close');
  }
}
